<template>
    <div
      class="modal fade"
      data-bs-backdrop="static"
      tabindex="-1"
      ref="modalElectricityGenerated"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title" style="font-weight: 600">ELECTRICITY GENERATED (TWH)</div>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import IconSvg from "@/components/IconSvg.vue";
  
  export default {
    props: ["showModal"],
    components: {
      IconSvg,
    },
  
    data() {
      return {
        modal: null,
      };
    },
  
    mounted() {
      this.modal = new bootstrap.Modal(this.$refs.modalElectricityGenerated);
    },
  
    methods: {
      closeModal() {
        this.$emit("closeModal", false);
      },
    },
  
    watch: {
      showModal() {
        if (this.showModal) {
          this.modal.show();
        } else {
          this.modal.hide();
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .custom-modal-width {
    max-width: 455px;
    width: 100%;
  }
  </style>
  